const convertUrlToHttps = url => !!url && url.replace(/^http:\/\//i, 'https://')

export default convertUrlToHttps
